module.exports = __webpack_public_path__ + "img/visio.1828883f.png";